import { Icon } from '@iconify/react';
import { Box, Dialog, DialogContent, DialogContentText, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import Image from './Image';
import { isEmpty } from 'lodash';

export default function EventDialog({ open, onClose, item }) {
  const { title, desc, url, date, location } = item;
  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} scroll="paper">
      <DialogContent sx={{ mb: 5 }}>
        <Stack width={1}>
          <Box
            position="absolute"
            top={0}
            left={0}
            height={200}
            width={1}
            sx={{
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundImage: 'url(/assets/overlay.svg), url(/assets/background/AdobeStock_406501003.jpg)',
            }}
          />
          <Stack width={1} direction="row" justifyContent="flex-end">
            <IconButton onClick={onClose}>
              <Icon icon="eva:close-fill" />
            </IconButton>
          </Stack>
          <Stack width={1} direction={{ xs: 'column-reverse', md: 'row' }} justifyContent="space-between" p={2}>
            <Stack mt={20} width={{ xs: 1, md: 0.5 }}>
              <Typography variant="h3"> {title} </Typography>
              <Stack width={1} direction="row" spacing={1}>
                <Stack>
                  <Typography> {date} </Typography>
                </Stack>
                <Stack>{!isEmpty(location) && <Typography> à {location} </Typography>}</Stack>
              </Stack>
            </Stack>
            <Stack>
              <Image src={url} sx={{ height: { xs: 200, md: 1 }, width: { xs: 200, md: 350 }, borderRadius: 2 }} />
            </Stack>
          </Stack>
        </Stack>
        <DialogContentText sx={{ whiteSpace: 'pre-line', textAlign: 'justify' }}>{desc}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
